import React from 'react';

import { Entity } from '@backstage/catalog-model';
import { FeatureFlagged } from '@backstage/core-app-api';
import { EntitySwitch, isKind } from '@backstage/plugin-catalog';

import {
  ApiPage,
  ComponentPage,
  DomainPage,
  RepositoryEntityPage,
  GroupPage,
  SystemPage,
  UserPage,
  GithubActionAllowListPage,
  ResourceEntityPage,
  ProxyPage,
  KaaPTenantEntityPage,
} from './Pages';
import { DefaultEntityPage } from './Pages/DefaultEntityPage';

const isKaapTenantResource = (entity?: Entity) => {
  if (!entity) {
    return false;
  }
  const isResource = isKind('resource')(entity);
  const type = (entity?.spec as any)?.type;
  return (
    isResource &&
    typeof type === 'string' &&
    type.toLowerCase() === 'kaap-tenant'
  );
};

export const entityPage = (
  <EntitySwitch>
    <EntitySwitch.Case if={isKind('component')} children={ComponentPage} />
    <EntitySwitch.Case
      if={isKind('repository')}
      children={RepositoryEntityPage}
    />
    <EntitySwitch.Case if={isKind('api')} children={ApiPage} />
    <EntitySwitch.Case if={isKind('group')} children={GroupPage} />
    <EntitySwitch.Case if={isKind('user')} children={UserPage} />
    <EntitySwitch.Case if={isKind('system')} children={SystemPage} />
    <EntitySwitch.Case if={isKind('domain')} children={DomainPage} />
    <EntitySwitch.Case if={isKaapTenantResource}>
      <FeatureFlagged with="show-kaap-old">{ResourceEntityPage}</FeatureFlagged>
      <FeatureFlagged without="show-kaap-old">
        {KaaPTenantEntityPage}
      </FeatureFlagged>
    </EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('resource')} children={ResourceEntityPage} />
    <EntitySwitch.Case if={isKind('proxy')} children={ProxyPage} />

    <EntitySwitch.Case
      if={isKind('githubaction')}
      children={GithubActionAllowListPage}
    />
    <EntitySwitch.Case>{DefaultEntityPage}</EntitySwitch.Case>
  </EntitySwitch>
);
